<ng-otp-input [formCtrl]="control" [config]="otpConfig"></ng-otp-input>
